// Round K — dekking per locatie: teksten die in Beheer en op het opnemen-scherm terugkomen.
export const UNKNOWN_SITE = "__zonder_locatie__";

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

export function coverageLine(row) {
  if (!row) return "";
  const parts = [
    row.covered.length ? `Bekend voor ${row.covered.join(", ")}` : "Nog voor geen enkele locatie bekend",
  ];
  if (row.open.length) parts.push(`nog open voor ${plural(row.open.length, "locatie", "locaties")}`);
  if (row.unknown_count) parts.push(plural(row.unknown_count, "antwoord zonder locatie", "antwoorden zonder locatie"));
  return parts.join(" · ");
}

export function siteGapsLine(locations, count) {
  if (!locations?.length || !count) return "";
  return `Voor ${locations.join(", ")} nog ${plural(count, "vraag", "vragen")} open`;
}

// Round L — one part per location that still has open questions, e.g.
// "Voor Aalsmeer nog 3 vragen open · Voor Amsterdam nog 5 vragen open".
export function siteGapsLines(perLocation) {
  return (perLocation || [])
    .filter((p) => p?.name && p.open_count > 0)
    .map((p) => siteGapsLine([p.name], p.open_count))
    .join(" · ");
}
